import { useMemo, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dropdown, Overlay, Popover, PopoverContent } from 'react-bootstrap'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

import { createRouteCourseCertificatesGenerate } from 'enum/routes'
import { Course } from 'graphqlAPI'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../constants'

interface DownloadCertificatesProps {
  course: Course
  nodesCount: number
  selected: string[]
  allSelected: boolean
  q?: [] | undefined
  search: string
}

export const DownloadCertificates = ({
  course,
  nodesCount,
  selected,
  allSelected,
  q,
  search,
}: DownloadCertificatesProps) => {
  const tRelative = useTranslationRankmi({ prefix })
  const { certificatesCount } = course

  const target = useRef(null)
  const [show, setShow] = useState(false)

  const selectedCertificates = !allSelected
    ? selected.length
    : nodesCount - selected.length
  const disabled =
    !nodesCount ||
    !certificatesCount ||
    (selected.length === 0 && !allSelected) ||
    selectedCertificates > 100

  const popoverText = useMemo(() => {
    if (selectedCertificates > 100)
      return tRelative('actions.popovers.limitExceeded')
    if (!certificatesCount)
      return tRelative('actions.popovers.courseWithoutCertificate')
    if (!selected.length && !allSelected)
      return tRelative('actions.popovers.selectParticipants')
    if (allSelected) return tRelative('actions.popovers.allParticipants')
    if (!allSelected && !selected.length)
      return tRelative('actions.popovers.noCertificates')
    return null
  }, [certificatesCount, tRelative, selected.length, allSelected])

  const route = createRouteCourseCertificatesGenerate(
    {
      courseId: course.id,
    },
    {
      allSelected,
      users: selected,
      q: q,
      search: search,
    }
  )

  return (
    <>
      <div
        ref={target}
        onMouseEnter={() => {
          setShow(true)
        }}
        onMouseLeave={() => setShow(false)}
      >
        <Dropdown.Item disabled={disabled} href={route} target="_blank">
          {tRelative('actions.options.downloadCertificates', {
            count: selectedCertificates,
          })}
          {(allSelected || selectedCertificates > 100) && (
            <FontAwesomeIcon icon={faInfoCircle} className="ml-2" />
          )}
        </Dropdown.Item>
      </div>
      <Overlay target={target.current} show={show && !!popoverText}>
        <Popover id="popover-download-certificates">
          <PopoverContent>{popoverText}</PopoverContent>
        </Popover>
      </Overlay>
    </>
  )
}
